import lottieReact from "lottie-react";
import { cjsDefault } from "../../lib/cjs-default";
import reactFadeIn from "react-fade-in/lib/FadeIn";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import BlenderOpenAnimation from "../../assets/animations/open.json";

const Lottie = cjsDefault(lottieReact);
const FadeIn = cjsDefault(reactFadeIn);

export default function ForYouBlenderEmpty() {
  const { t } = useTranslation();

  return (
    <FadeIn className="flex-1 pt-[calc(16px+var(--safe-area-top))] px-11 pb-16 flex flex-col items-center gap-8">
      <Lottie animationData={BlenderOpenAnimation} loop autoplay />
      <div className="text-black text-center font-dm-sans text-[25px] font-bold leading-[115%] tracking-[-0.002px]">
        <Trans
          i18nKey="Your blender is <span>empty!</span>"
          components={{ span: <span className="text-secondary-raspberry-1" /> }}
        />
      </div>
      <div className="text-black text-center font-dm-sans text-base font-medium leading-[140%] tracking-[-0.002px]">
        <Trans
          i18nKey="Explore more content on the <b>Discovery page</b> to receive more personalized recommendations in the <b>For You</b> section."
          components={{ b: <b /> }}
        />
      </div>
      <Link
        to="/discovery"
        className="px-[60px] py-4 rounded-pill bg-primary-yellow text-primary-black text-center font-dm-sans text-sm font-medium leading-[100%] tracking-[-0.07px] no-underline"
      >
        <span>{t("Discovery")}</span>
      </Link>
    </FadeIn>
  );
}
